import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Col, Row } from "reactstrap";
import { NavLink } from "react-router-dom";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import logo from "../../../assets/img/givbeeLogo.png";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { ApForgetPassword_Url } from "../../../provider/ServiceUrl";

class AdminForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      render: false,
    };
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }
  forgotPasswordBackend() {
    const postObject = {
      header: {},
      appuser: {
        email: this.state.email,
      },
    };

    AdminFetchServerData.callPostService(ApForgetPassword_Url, postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/ApResetPassword", {
            state: {
              email: this.state.email,
            },
          });
        } else if (output.status === "FAIL") {
          PtsAlert.error("Please enter Registered User ID");
        }
      })
      .catch((error) => { });
  }
  render() {
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0" id="signIn">
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center apLeftBackground">
            <div className="mx-auto">
              <div className="logoBackground">
                <img
                  src={logo}
                  className="img-fluid logoImage"
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
              </div>
            </div>
          </div>
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <div className="adminSigninHeding text-start ps-2">
                Admin Panel
              </div>
              <Row>
                <Col md={12} className="forgotPasswordSubTitle">
                  <h4>Forgot Password?</h4>
                  <p>
                    We will send you verification code on mobile and in email
                    to reset your password.
                  </p>
                </Col>
              </Row>
              <ValidatorForm
                ref="form"
                // id="formAuthentication"
                // className="mb-3"
                onSubmit={this.forgotPasswordBackend.bind(this)}
              >
                <div className="mb-3">
                  <label className="form-label" htmlFor="multiStepsEmail">
                    User ID (email address)
                  </label>
                  <input
                    title=""
                    required
                    type="email"
                    name="multiStepsEmail"
                    value={this.state.email}
                    onChange={this.handleEmailChange.bind(this)}
                    id="multiStepsEmail"
                    className="form-control"
                    aria-label="john.doe"
                  />{" "}
                </div>
                <button className="goButton d-grid w-100">
                  Send Verification Code
                </button>
              </ValidatorForm>
              <div style={{ textAlign: "left", padding: "1em 0em" }}>
                <NavLink to="/ApLogin">
                  <ArrowBackIosNewIcon />
                  Back Sign In
                </NavLink>
                &nbsp;&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(AdminForgotPassword);
